export const getIndividualSessions = async (api, page = 0, pageSize = 50) => {
  return api.get(`/api/v1/session/individual?page=${page}&pageSize=${pageSize}`);
};

export const getIndividualSessionDetails = async (api, publicId) => {
  return api.get(`/api/v1/session/individual/${publicId}`);
};

export const updateIndividualSessionTitle = async (api, publicId, title) => {
  return api.put(`/api/v1/session/individual/${publicId}`, { title });
};

export const getHiddenIndividualSessions = async (
  api,
  page = 0,
  pageSize = 50,
) => {
  return api.get(
    `/api/v1/session/individual?page=${page}&pageSize=${pageSize}&isHidden=true`,
  );
};

export const setIndividualSessionHiddenStatus = async (
  api,
  sessionIds,
  isHidden,
) => {
  return api.put("/api/v1/session/individual/hidden-status", {
    sessionIds,
    isHidden,
  });
};
